import React, { useRef } from 'react'
import Portal from '../portal/portal'
import PortalTop from '../portal/portaltop'


export const ModalRight = ({
  children,
  open = false,
  style = { maxHeight: `calc(100vh - 0px)`, width: '260px', top: `0px` },
  action= ()=> null,
}) => {

  return open ? (
    <PortalTop name="modal-sidebar" forceLast={true}>
      <div
        id='box-sidebar-right'
        className={open ? 'open-sidebar' : ''}
        style={style}
      >
        {children}
      </div>
    </PortalTop >
  ) :null
}
